import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <nav className="app-footer-links" aria-label="Юридические документы">
          <Link to="/legal/offer">Оферта</Link>
          <Link to="/legal/privacy">Политика ПДн</Link>
          <Link to="/legal/requisites">Реквизиты</Link>
        </nav>
        <span className="app-footer-copy">ИП Баланин Д. © {year}</span>
      </div>
    </footer>
  );
};

export default Footer;
